import type { Challenge, Status } from "../api/languageChallenge";
import { type User } from "../api/v2";
import timerImage from "../images/timer.svg";
import styles from "../styles/RegisteredPage.module.scss";

import Leaderboard from "./Leaderboard";
import Profile from "./Profile";
import TimeRemaining from "./TimeRemaining";

export interface Props {
  status: Status;
  user: User;
  shownChallenge: Challenge;
}

/** Shows the user's progress in the active challenge they are registered for */
const RegisteredPage = ({ status, user, shownChallenge }: Props) => (
  <div className={styles.wrap}>
    <div>
      <div className={styles["profile-header"]}>
        <h3 className={styles["timer-text"]}>
          <img className={styles["timer-image"]} src={timerImage} />
          <TimeRemaining
            endTimeSecondsSinceEpoch={status.dueTimeSecondsSinceEpoch}
          />
        </h3>
        <h2 className={styles["profile-title"]}>Your Progress</h2>
      </div>
      <Profile
        allowReset={true}
        className={styles.profile}
        shownChallenge={shownChallenge}
        status={status}
        user={user}
      />
    </div>
    <div>
      <h2 className={styles["leaderboard-title"]}>Top 10 Leaderboard</h2>
      <Leaderboard
        challengeId={shownChallenge.id}
        className={styles.leaderboard}
      />
    </div>
  </div>
);
export default RegisteredPage;
